module.exports = {"singular":"Event","plural":"Events","pl_name":"PL name","pl_email":"PL e-mail","pl_salutation":"PL salutation","name":"Event"};